import React, { createContext, useContext, useState } from "react";
import { Theme } from "./theme";

const Crypto = createContext();

const CryptoContext = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  const [theme, setTheme] = useState(Theme.Night);

  return (
    <Crypto.Provider value={{ currency, setCurrency, theme, setTheme }}>
      {children}
    </Crypto.Provider>
  );
};

export default CryptoContext;

export const CryptoState = () => useContext(Crypto);
